var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-2"},[_c('v-img',{staticClass:"mx-auto",attrs:{"src":_vm.imageUrl,"alt":_vm.data.name,"width":_vm.data.width + '%',"max-height":_vm.data.height ? _vm.data.height + 'px' : null,"contain":_vm.data.contain}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }